import { render, staticRenderFns } from "./ResActionGroupHeader.vue?vue&type=template&id=28399e54&scoped=true"
import script from "./ResActionGroupHeader.vue?vue&type=script&lang=js"
export * from "./ResActionGroupHeader.vue?vue&type=script&lang=js"
import style0 from "./ResActionGroupHeader.vue?vue&type=style&index=0&id=28399e54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28399e54",
  null
  
)

export default component.exports